import { render, staticRenderFns } from "./ChatAgnostic.vue?vue&type=template&id=5d6765e3"
import script from "./ChatAgnostic.vue?vue&type=script&lang=js"
export * from "./ChatAgnostic.vue?vue&type=script&lang=js"
import style0 from "./ChatAgnostic.vue?vue&type=style&index=0&id=5d6765e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports